import { DEFAULT_ROLE_SLUGS, DefaultRoleSlug } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant, Input } from "@swivl-mono/ui";
import { useState } from "react";

import ModalModel from "../../../../Models/Modal/Modal.Model";
import RolesModel from "../../../../Models/Roles/Roles.Model";

export function CreateNewRoleModal() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [name, setName] = useState("New Role");
  const [parentSlug, setParentSlug] = useState<DefaultRoleSlug>("agent");
  const { defaultRoles } = RolesModel.useState();

  return (
    <div>
      <Input value={name} onChange={(e) => setName(e.target.value)} />

      <div className="mt-3">
        <label className="mb-1 block text-sm font-semibold text-grey-700">Parent role</label>
        <select
          className="w-full rounded border border-grey-300 px-3 py-2 text-sm"
          value={parentSlug}
          onChange={(e) => setParentSlug(e.target.value as DefaultRoleSlug)}
        >
          {DEFAULT_ROLE_SLUGS.map((slug) => (
            <option key={slug} value={slug}>
              {defaultRoles?.[slug]?.name ?? slug}
            </option>
          ))}
        </select>
        <p className="mt-1 text-xs text-grey-500">
          The new role inherits permissions and escalation eligibility from its parent unless explicitly overridden.
        </p>
      </div>

      {error && <div className="text-red-500">{error}</div>}

      <div className="mt-5 flex flex-row justify-end pb-3">
        <Button
          variant={ButtonVariant.GHOST}
          loading={loading}
          onClick={() => {
            ModalModel.hideModal();
          }}
          className="mr-2"
        >
          Cancel
        </Button>
        <Button
          color={ButtonColor.ORANGE}
          loading={loading}
          onClickAsync={async () => {
            try {
              await RolesModel.createRole(name, parentSlug);
              ModalModel.hideModal();
            } catch (e: any) {
              setError(e.message);
            }
          }}
        >
          Create
        </Button>
      </div>
    </div>
  );
}
